<template>
  <svg width="24px" height="24px"
       viewBox="0 0 24 24" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/24x24/dashboard/black</title>
    <g id="atoms/icons/24x24/dashboard/black" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M19.2,3.2 C20.5254834,3.2 21.6,4.2745166 21.6,5.6 L21.6,18.4432432 C21.6,19.7687266 20.5254834,20.8432432 19.2,20.8432432 L4.8,20.8432432 C3.4745166,20.8432432 2.4,19.7687266 2.4,18.4432432 L2.4,5.6 C2.4,4.2745166 3.4745166,3.2 4.8,3.2 L19.2,3.2 Z M20,7.999 L3.999,7.999 L4,18.4432432 C4,18.885071 4.3581722,19.2432432 4.8,19.2432432 L19.2,19.2432432 C19.6418278,19.2432432 20,18.885071 20,18.4432432 L20,7.999 Z M14,12.8 L14,17.6 L12.4,17.6 L12.4,12.8 L14,12.8 Z M10.8,16 L10.8,17.6 L5.2,17.6 L5.2,16 L10.8,16 Z M16.4,10.4 L16.4,17.6 L14.8,17.6 L14.8,10.4 L16.4,10.4 Z M18.8,14.4 L18.8,17.6 L17.2,17.6 L17.2,14.4 L18.8,14.4 Z M10,13.2 L10,14.8 L5.2,14.8 L5.2,13.2 L10,13.2 Z M10.8,10.4 L10.8,12 L5.2,12 L5.2,10.4 L10.8,10.4 Z M19.2,4.8 L4.8,4.8 C4.3581722,4.8 4,5.1581722 4,5.6 L3.999,6.399 L20,6.399 L20,5.6 C20,5.1581722 19.6418278,4.8 19.2,4.8 Z" id="Combined-Shape"
            fill-rule="nonzero"></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
